"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installDayjsPlugins = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));

var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));

var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));

var _timezone = _interopRequireDefault(require("dayjs/plugin/timezone"));

var _duration = _interopRequireDefault(require("dayjs/plugin/duration"));

var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));

var _isSameOrBefore = _interopRequireDefault(require("dayjs/plugin/isSameOrBefore"));

var _isSameOrAfter = _interopRequireDefault(require("dayjs/plugin/isSameOrAfter"));

var _advancedFormat = _interopRequireDefault(require("dayjs/plugin/advancedFormat"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// plugins
// localization - dayjs().format("LL")
// parsing date input - dayjs("05/02/69 1:33:03 PM -05:00", "MM/DD/YY").format()
// dependent on utc plugin - dayjs().tz("America/New_York")
// dayjs.duration(100)
// dayjs('2010-10-20').isBetween('2010-10-19', dayjs('2010-10-25'), 'year')
// dayjs('2010-10-20').isSameOrBefore('2010-10-19', 'year')
// dayjs('2010-10-20').isSameOrAfter('2010-10-19', 'year')
// dayjs().format('Q Do k kk X x')
// dayjs().fromNow()
var installDayjsPlugins = function installDayjsPlugins() {
  // install all plugins here
  _dayjs["default"].extend(_localizedFormat["default"]);

  _dayjs["default"].extend(_customParseFormat["default"]);

  _dayjs["default"].extend(_utc["default"]);

  _dayjs["default"].extend(_timezone["default"]);

  _dayjs["default"].extend(_duration["default"]);

  _dayjs["default"].extend(_isBetween["default"]);

  _dayjs["default"].extend(_isSameOrBefore["default"]);

  _dayjs["default"].extend(_isSameOrAfter["default"]);

  _dayjs["default"].extend(_advancedFormat["default"]);

  _dayjs["default"].extend(_relativeTime["default"]);
};

exports.installDayjsPlugins = installDayjsPlugins;